import type { UseMutationResult } from "@tanstack/react-query";

import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Card, Stack, Typography } from "@mui/material";

import Modal from "./Modal";

interface IProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  message: string;
  onAccept?: () => void;
  mutation?: UseMutationResult<void, unknown, void, unknown>;
}

export default function ConfirmModal({ open, setOpen, onAccept, message, mutation }: IProps) {
  const onClose = () => {
    setOpen(false);
  };
  const handleOnAccept = () => {
    if (mutation) {
      mutation.mutate();
    }
  };

  return (
    <Modal open={open} onClose={onClose} size="xs">
      <Card sx={{ p: 3 }}>
        <Stack spacing={1}>
          <Typography variant="h6" fontWeight="800">
            ایا مطمئن هستید؟
          </Typography>
          <Typography>{message}</Typography>
        </Stack>

        <Stack direction="row" mt={5} spacing={1}>
          <Button fullWidth size="large" onClick={onClose}>
            انصراف
          </Button>
          <LoadingButton fullWidth size="large" variant="contained" onClick={handleOnAccept} loading={mutation?.isLoading}>
            تایید
          </LoadingButton>
        </Stack>
      </Card>
    </Modal>
  );
}
